import React from 'react';
import NavBar from '../NavBar';
import styled from 'styled-components';

function Header() {
  return (
    <StyledHeader>
      <Logo>PsychoChess Trainer</Logo>
      <SubheaderGrid>
        <DictEntry>
          <DictLine>
            <Headword>шахматы</Headword>
            {' '}<Pronunciation>/shakh·ma·ty/</Pronunciation>
          </DictLine>
          <DictLine>
            <PartOfSpeech>n.</PartOfSpeech>
            {' '}<Definition>lit. "kill{'\u2011'}king"</Definition>
            {' '}<Gloss>🔪♔</Gloss>
          </DictLine>
          <DictLine>
            <Definition indent>you best not miss</Definition>
          </DictLine>
          <DictLine>
            <Usage>see also:</Usage>
            {' '}<Definition>checkmate</Definition>
          </DictLine>
        </DictEntry>
        <EmojiRow>
          <EmojiPill>🤴</EmojiPill>
          <EmojiPill>💀</EmojiPill>
        </EmojiRow>
        <Blurb>
          <CompactLine>Pinpoint your opponent's most losing response to your repertoire.</CompactLine>
          <BlurbSpacer />
          And crush them.
        </Blurb>
      </SubheaderGrid>
      <NavPill>
        <NavBar />
      </NavPill>
    </StyledHeader>
  );
}

export default Header;

const StyledHeader = styled.header`
  display: grid;
  grid-template-columns: 1fr auto;
  grid-template-rows: auto auto;
  gap: 2px 24px;
  padding: 16px 22px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 20px;
  box-shadow: var(--shadow-md);
  backdrop-filter: blur(18px);
  flex-shrink: 0;

  @media (max-width: 980px) {
    grid-template-columns: 1fr;
    padding: 14px 16px;
  }
`;

const Logo = styled.h1`
  grid-column: 1 / -1;
  font-size: 70px;
  font-weight: 600;
  margin: 0;
  color: var(--text);
  letter-spacing: -0.01em;
  line-height: 1.15;
`;

const NavPill = styled.div`
  grid-column: 2;
  grid-row: 2;
  align-self: center;

  @media (max-width: 980px) {
    grid-column: 1;
    grid-row: 3;
  }
`;

const DictEntry = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-top: 6px;
  padding: 8px 12px;
  font-size: 13px;
  line-height: 1.5;
  color: var(--text-faint);
  border: 1.5px dashed rgba(139, 90, 43, 0.35);
  border-radius: 8px;
  width: fit-content;
`;

const DictLine = styled.div`
  display: flex;
  align-items: center;
  gap: 0.35em;
`;

const Headword = styled.span`
  font-weight: 700;
  font-style: italic;
  color: var(--text-soft);
  letter-spacing: 0.02em;
`;

const Pronunciation = styled.span`
  font-style: italic;
  opacity: 0.55;
  letter-spacing: 0.01em;
`;

const PartOfSpeech = styled.span`
  font-style: italic;
  font-weight: 600;
  opacity: 0.45;
`;

const Definition = styled.span`
  color: var(--text-soft);
  ${(p) => p.indent && 'padding-left: 1em;'}
`;

const Usage = styled.span`
  font-style: italic;
  opacity: 0.6;
`;

const Gloss = styled.span`
  font-style: normal;
`;

const SubheaderGrid = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  grid-template-rows: auto auto;
  gap: 8px 16px;
  margin-top: 6px;
  align-items: start;
`;

const Blurb = styled.div`
  grid-column: 2;
  grid-row: 1 / 3;
  padding: 14px 18px;
  font-size: 26px;
  line-height: 1.5;
  color: var(--text-soft);
  border: 1.5px dashed rgba(139, 90, 43, 0.35);
  border-radius: 8px;
  max-width: 500px;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const BlurbSpacer = styled.div`
  height: 0.5em;
`;

const CompactLine = styled.span`
  line-height: 1.15;
`;

const EmojiRow = styled.div`
  display: flex;
  gap: 8px;
`;

const EmojiPill = styled.span`
  font-size: 38px;
  line-height: 1;
  padding: 4px 10px;
  border: 1px dashed rgba(139, 90, 43, 0.35);
  border-radius: 999px;
`;
